import {Injectable} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {map, Observable} from "rxjs";
import {HttpClient, HttpParams} from "@angular/common/http";


@Injectable({
  providedIn: 'root'
})
export class AttendanceService {
  baseURL = environment.baseUrl + 'attendance';

  constructor(private http: HttpClient) {
  }

  getAllAttendanceByLocation(eventId: any, location: any, page: number, size: number, keyword: string): Observable<any> {
    return this.http.get<any>(`${this.baseURL}/event/${eventId}/location/${location}`, {
      params: new HttpParams()
        .append('page', page)
        .append('size', size)
        .append('keyword', keyword)
    })
  }


  saveAttendance(eventId: any, location: any, email: string) {
    const params = new HttpParams()
      .set('email', email)
    return this.http.post<any>(`${this.baseURL}/event/${eventId}/location/${location}`, {}, {params}).pipe(
      map((res: any) => {
        return res;
      })
    );
  }

  exportExcel(eventId:any,locationId:any){
    return this.http.get(`${this.baseURL}/event/excel/${eventId}/location/${locationId}`, {
      responseType: 'blob'
    });
  }


}
